import axios from "axios";
import baseURL from "./../api";
class TicketService {

    getTicketHistory(pageNumber, rowsPage, status) {
        return axios.get(`${baseURL}/tickets/history?size=${rowsPage}&status=${status}&page=${pageNumber}`);
    }

    getSubjectAndCategory(){
        return axios.get(`${baseURL}/config/drop-down/ticket-category`);

    }

    createTicket(data) {
        return axios.post(`${baseURL}/tickets/create`,data,{
            headers: {
                'Content-Type': 'multipart/form-data',
               
              },
        }
            
        );

    }

    viewTicket(id) {
        return axios.get(`${baseURL}/tickets/${id}`);
 
    }
    replyTicket(id,data) {
        return axios.put(`${baseURL}/tickets/${id}`,data);
 
    }
    getViewTicketFormData(){
        const token = JSON.parse(localStorage.getItem("viewTicketFormData"));
        return token;
      }
      setViewTicketFormData(data){
       
        localStorage.setItem("viewTicketFormData", JSON.stringify(data));
      }
   
}
export default new TicketService();